import { render, staticRenderFns } from "./myMiniBankCard.vue?vue&type=template&id=1f4c3a70&scoped=true&"
import script from "./myMiniBankCard.vue?vue&type=script&lang=js&"
export * from "./myMiniBankCard.vue?vue&type=script&lang=js&"
import style0 from "./myMiniBankCard.vue?vue&type=style&index=0&id=1f4c3a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c3a70",
  null
  
)

export default component.exports